<template>
  <div id="FileCategory">
    <div v-if="list">
      <v-container class="pa-0">
        <v-layout>
          <router-link to="/FileCategoryAdd">
          <v-flex class="xs12 sm12 mb-5">
            <v-btn fab absolute right class="mr-3 pf-btn-fab">
              <v-icon>add</v-icon>
            </v-btn>
          </v-flex>
          </router-link>
        </v-layout>       
      </v-container>
      <v-container v-if="fileCategoryList.length == 0" class="text-center">
        <img src="static/NoBlogs.jpg" class="noItemsTemplate">
        <h4 class="pf-text-green"><b>No Category Found !! </b></h4>
    </v-container>
      <v-container v-if="fileCategoryList.length > 0">
        <v-card class="mt-3">
          <v-data-table
            disable-initial-sort
            :headers="headers"
            :items="fileCategoryList"
            :search="search" 
            class="pf-data-table"
            ref="sortableTable"
            :pagination.sync="pagination" 
          >
            <template v-slot:items="props">
              <tr class="sortableRow" :key="itemKey(props.item)">
              <td>{{ props.item.name }}</td>
              <td align="right">
                <v-btn icon class="ma-0" @click="editItem(props.item)">
                  <v-icon size="22" color="grey darken-2">edit</v-icon>
                </v-btn>
                <v-btn icon class="ma-0" @click="deleteItem(props.item)">
                  <v-icon size="22" color="grey darken-2">delete_outline</v-icon>
                </v-btn>
              </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-container>
    </div>
    <div id="fileCategoryEdit" v-if="!list">
      <div id="fileCategoryEdit">
      <v-layout wrap row mb-1>
      <v-flex md6 pb-4 style="min-height:70px;">
        <v-btn fab left class="ml-3 pf-btn-fab" @click="backToList()">
          <v-icon>arrow_back</v-icon>
        </v-btn>
         </v-flex>
        <v-flex offset-md1 md5 v-if="selectedData">
        <div style="float:right">
          <v-btn class="pf-btn pf-btn-cancel" @click="backToList()">
            <v-icon size="16" class="pr-1">cancel</v-icon>
            <div>Cancel</div>
          </v-btn>
          <v-btn class="pf-btn pf-btn-save" @click="save">
            <v-icon size="16" class="pr-1">check_circle</v-icon>
            <div>Save</div>
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
    <v-form ref="fileCategoryEdit">
      <v-container>
        <v-layout>
          <v-flex class="xs12 sm6 md7">
            <v-text-field label="Name" :rules="rules" v-model.trim="editableFileCategory.name" class="required pr-4 pl-4" @input="changedData" required></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex class="xs12 sm6 md7">
            <v-textarea label="Description" rows="3" :rules="descriptionRules" v-model.trim="editableFileCategory.description" class="required pr-4 pl-4" @input="changedData" required></v-textarea>
          </v-flex>
        </v-layout>
      <v-layout>
          <v-flex class="xs12 sm6 md7">
            <v-combobox
              v-model="editableFileCategory.notify"
              :items="agencyAdminList"
              label="Select to notify"
              item-text="name"
              item-value="human"
              multiple
              class="pr-4 pl-4"
              @input="changedData"
            ></v-combobox>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
      <v-layout class="editor-button-container">
        <v-flex xs12 class="button-container text-xs-right" v-if="selectedData">
          <div class="d-inline-flex">
            <v-btn class="pf-btn pf-btn-cancel" @click="backToList()">
              <v-icon size="16" class="pr-1">cancel</v-icon>
              <div>Cancel</div>
            </v-btn>
            <v-btn class="pf-btn pf-btn-save" @click="save">
              <v-icon size="16" class="pr-1">check_circle</v-icon>
              <div>Save</div>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
  </div>
    </div>
  </div>
</template>
<script>
/* global session store config */
import draggable from 'vuedraggable';
import Sortable, { MultiDrag, Swap } from 'sortablejs';
import swal from 'sweetalert2';
import { getCollection, remove, update, validateUrl } from '../helpers/helpers';
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default {
  data: () => ({
    editIndex: -1,
    list: true,
    itemKeys: new WeakMap(),
    currentItemKey: 0,
    search: '',
    headers: [
      { text: 'Categories', value: 'name', align: 'left' },
      { text: '', sortable: false },
    ],
    pagination: {
      sortBy: 'sort_no', // The field that you're sorting by
      descending: false,
      rowsPerPage: config.dom.rowsPerPage
    },
    selectedData: false,
    editableFileCategory: {},    
    rules: [
      v => !!v.trim() || 'Name is required'
    ],
    descriptionRules: [
      v => !!v.trim() || 'Description is required'
    ],
  }),
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  computed: {
    fileCategoryList: {
      get () {
        return store.state.FileCategory;
      },
      set (value) {
        store.commit('setFileCategory', value);
      }
    },
    agencyAdminList: {
      get () {
        return store.state.AdminList;
      },
      set (value) {
        store.commit('setAdminList', value);
      }
    }
  },
  created () {
    this.getFileCategories();
    this.getAgencyAdmins();
  },
  mounted () {
    //
  },
  methods: {
    async getFileCategories () {
      if (!this.fileCategoryList.length) {
        let entity = `FileCategory`;
        let { error, data } = await getCollection(entity, true);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.fileCategoryList = data;
          }
        }
      }
    },
    deleteItem (item) {
      swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          (async () => {
            let { error, data, status } = await remove('FileCategory', item.id);
            if (error) {
              console.log('error', error);
            } else {
              const index = this.fileCategoryList.indexOf(item);
              this.fileCategoryList.splice(index, 1);
              swal.fire(
                'Deleted!',
                `The category "${item.name}" has been deleted.`,
                'success'
              );
            }
          })();
        }
      });
    },
    itemKey (item) {
      if (!this.itemKeys.has(item)) this.itemKeys.set(item, ++this.currentItemKey);
      return this.itemKeys.get(item);
    },
    changedData () {
      this.selectedData = true;
    },
    editItem (item) {
      this.links = [];
      this.editIndex = this.fileCategoryList.indexOf(item);
      window.getApp.$emit('pageSubHeader', 'Edit');
      this.list = false;
      this.editableFileCategory = item;
      let humanIds = this.editableFileCategory.notify;
      let agencyData = this.agencyAdminList;
      let editData = { ...this.editableFileCategory };
      editData.notify = [];
      humanIds.forEach(function (v) { 
        let agencyIndex = agencyData.findIndex(item => item.human === v);
        let adminName = agencyData[agencyIndex].name;
        editData.notify.push({
          'name': adminName,
          'human': v
        });
      });
      this.editableFileCategory = { ...editData };
    },
    backToList () {
      window.getApp.$emit('pageSubHeader', '');
      this.list = true;
      this.editIndex = -1;

    },
    async save () {
      if (this.$refs.fileCategoryEdit.validate()) {
        this.selectedData = false;
        let selectedString = [];
        let editData = { ...this.editableFileCategory };
        editData.notify.forEach(function (v) { 
          selectedString.push(v.human);
        });
        editData.notify = selectedString;
        let { error, data } = await update('FileCategory', editData, editData.id);
        if (error) {
          this.selectedData = true;
          console.log('error', error);
        } else {
          this.fileCategoryList[this.editIndex] = data;
          swal.fire({
            type: 'success',
            title: 'Category updated successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.editIndex = -1;
              this.list = true;
              window.getApp.$emit('pageSubHeader', '');
            }
          });
        }
      }
    },
    async getAgencyAdmins () {
      if (!this.agencyAdminList.length) {
        let where = { is_admin: true };
        let attributes = 'name';
        let populate = [{ path: 'human', select: '_id name user' }];
        let { error, data } = await getCollection('Agency', true, 0, populate, where, attributes);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.agencyAdminList = data;
            this.agencyAdminList.map(function (item) {
              item.human = item.human[0].id;
              return item;
            });
          }
        }
      }
    },
  }
};
</script>
<style scoped>
#FileCategory >>> .v-textarea textarea {
    margin-top: 12px !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/FileCategories.vue